/** A list worth multiplying by: two or more entries, or nothing. */
const several = (list) => list && list.length > 1 ? list : [undefined];
export function planFrames({ modelIds, povIds, variantsPerPov, poseIds = [], backdropIds, attitudes, expressions, poseRefs, }) {
    const takes = Math.max(1, Math.floor(variantsPerPov) || 1);
    if (poseRefs?.length) {
        const frames = [];
        for (const modelId of modelIds) {
            let variantIndex = 0;
            for (const ref of poseRefs) {
                for (const backdropId of several(backdropIds)) {
                    for (const attitude of several(attitudes)) {
                        for (const expression of several(expressions)) {
                            frames.push({
                                modelId,
                                povId: ref.povId,
                                variantIndex: variantIndex++,
                                poseRefId: ref.id,
                                ...(backdropId ? { backdropId } : {}),
                                ...(attitude ? { attitude } : {}),
                                ...(expression ? { expression } : {}),
                            });
                        }
                    }
                }
            }
        }
        return frames;
    }
    /*
     * Poses cycle across the takes of a set-up, so asking for three frames of
     * one angle returns three different positions rather than the same one
     * re-rolled. Scenes, attitudes and expressions multiply instead: each take
     * is shot in every one chosen, so choosing two places doubles the roll.
     */
    const poseFor = (take) => poseIds.length ? poseIds[take % poseIds.length] : undefined;
    const frames = [];
    for (const modelId of modelIds) {
        for (const povId of povIds) {
            let variantIndex = 0;
            for (let take = 0; take < takes; take++) {
                for (const backdropId of several(backdropIds)) {
                    for (const attitude of several(attitudes)) {
                        for (const expression of several(expressions)) {
                            frames.push({
                                modelId,
                                povId,
                                variantIndex: variantIndex++,
                                poseId: poseFor(take),
                                ...(backdropId ? { backdropId } : {}),
                                ...(attitude ? { attitude } : {}),
                                ...(expression ? { expression } : {}),
                            });
                        }
                    }
                }
            }
        }
    }
    return frames;
}
/** How many frames the same input comes to, without building the list. */
export const countFrames = (input) => input.modelIds.length *
    (input.poseRefs?.length
        ? input.poseRefs.length
        : input.povIds.length * Math.max(1, Math.floor(input.variantsPerPov) || 1)) *
    several(input.backdropIds).length *
    several(input.attitudes).length *
    several(input.expressions).length;
/**
 * The plan input a roll's settings describe. The one place the settings'
 * lists are read, so the composer's count, the server's limit and the
 * orchestrator's plan cannot read them differently.
 */
export function planInputOf(settings, modelIds, povIds) {
    return {
        modelIds,
        povIds,
        variantsPerPov: settings.variantsPerPov,
        poseIds: settings.poseIds,
        backdropIds: settings.backdropIds,
        attitudes: settings.attitudes,
        expressions: settings.expressions,
        ...(settings.poseRefs?.length
            ? { poseRefs: settings.poseRefs.map((ref) => ({ id: ref.id, povId: ref.read.povId })) }
            : {}),
    };
}
//# sourceMappingURL=shotPlan.js.map